/**
 * Controller: MembershipCategoriesRemoveModal
 */
angular.module('acme.view.application.membership.categories.removeModal.controllers', [])
.controller('MembershipCategoriesRemoveModalController', [ '$scope', '$uibModalInstance', 'currentMembershipCategory', function ($scope, $uibModalInstance, currentMembershipCategory) {

    $scope.errors = [];

    $scope.model = {
      name: currentMembershipCategory.name
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);